export default __webpack_public_path__ + "static/media/ico-sq-13-climate.143836b0.svg";